import Parseable from '@/models/Parseable';
import { isQuotationCountry, QuotationCountry } from '@/constants/quotationCountries';

export default class User extends Parseable {

    public id!: string;
    public username!: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public phone?: string;
    public role?: string;
    public country?: QuotationCountry;

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<User>): User {
        const user = new User();
        Object.assign(user, object);
        if (!isQuotationCountry(user.country)) {
            user.country = undefined;
        }
        return user;
    }

    parseToObject(): any {
        const tmp: any = { ...this };
        return tmp;
    }
}
